import { customerRoutes } from "./customer";

export const PrivateRoutes = [...customerRoutes];
